import { render, staticRenderFns } from "./Packs.vue?vue&type=template&id=d2258c3e&scoped=true&"
import script from "./Packs.vue?vue&type=script&lang=ts&"
export * from "./Packs.vue?vue&type=script&lang=ts&"
import style0 from "./Packs.vue?vue&type=style&index=0&id=d2258c3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2258c3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2258c3e')) {
      api.createRecord('d2258c3e', component.options)
    } else {
      api.reload('d2258c3e', component.options)
    }
    module.hot.accept("./Packs.vue?vue&type=template&id=d2258c3e&scoped=true&", function () {
      api.rerender('d2258c3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/Packs.vue"
export default component.exports